import React, { useLayoutEffect } from "react";
import {
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  useIonRouter
} from "@ionic/react";

import { ReactComponent as DashboardIcon } from "../assets/graphics/team_dashboard.svg";
import { ReactComponent as BotIcon } from "../assets/graphics/smart_toy.svg";
import { ReactComponent as LobbiesIcon } from "../assets/graphics/workspaces.svg";
import { ReactComponent as HelpIcon } from "../assets/graphics/support.svg";
import Menu from "../components/Menu";
import PushListener from "../components/PushListener";
import { useAuthStore } from "../stores/auth.store";
import routes from "./routes";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";

const PagesWithoutNavBar = [
  "/",
  "/auth",
  "/intro",
  "/profile",
  "/completeProfile",
  "/password",
  "/passwordReset",
  "/notifications",
  "/dashboard",
  "/coins",
  "/activity",
  "/quoCoin",
  "/challenge",
  "/quest",
  "/quest/levels",
  /^\/bots\/[^/]+$/,
  /^\/challenge\/[^/]+$/,
  /^\/quest.*$/,
  /^\/lobbies\/[^/]+$/,
  /^\/botList\/[^/]+\/[^/]+$/,
  /^\/lobbyList\/[^/]+$/,
  /^\/quoCoin\/[^/]+$/,
  /^\/bots\/[^/]+\/trades\/[^/]+$/
];

const DarkPages = [
  "/",
  "/intro",
  "/auth",
  "/completeProfile",
  "/bots",
  "/notifications",
  "/dashboard",
  "/password",
  "/botList"
];

const RouterContainer: React.FC<any> = () => {
  const router = useIonRouter();
  const uid = useAuthStore(state => state.user?.uid);
  const pathname = router.routeInfo.pathname;

  // TODO: Can default to dark page
  useLayoutEffect(() => {
    document.body.classList.toggle(
      "dark",
      DarkPages.some(page => pathname.startsWith(page))
    );
  }, [pathname]);

  const getRoutes = () =>
    routes.map(route =>
      route.private ? (
        <PrivateRoute
          component={route.component}
          path={route.path}
          key={route.path}
          exact
        />
      ) : (
        <PublicRoute
          component={route.component}
          path={route.path}
          key={route.path}
          exact
        />
      )
    );

  const shouldHideNavBar = PagesWithoutNavBar.some(route => {
    if (typeof route === "string") {
      return route === pathname;
    } else {
      return route.test(pathname);
    }
  });

  const handleTabChange = (path: string) => {
    if (path === "/dashboard") {
      router.push(path);
    } else {
      router.push(path, "none", "replace");
    }
  };

  return (
    <>
      {uid && <Menu />}
      <PushListener />
      <IonTabs>
        <IonRouterOutlet id="menuContent">{getRoutes()}</IonRouterOutlet>
        <IonTabBar
          slot="bottom"
          hidden={shouldHideNavBar}
          className="flex justify-around py-4 bg-black"
        >
          <IonTabButton
            tab="dashboard"
            className="max-w-fit bg-transparent"
            onClick={() => handleTabChange("/dashboard")}
          >
            <DashboardIcon
              className={`mb-2 ${
                pathname.startsWith("/dashboard") && "selected-fill"
              }`}
            />
            <IonLabel
              color={pathname.startsWith("/dashboard") ? "secondary" : ""}
            >
              Dash
            </IonLabel>
          </IonTabButton>
          <IonTabButton
            tab="bots"
            onClick={() => handleTabChange("/bots")}
            className="max-w-fit bg-transparent"
          >
            <BotIcon
              className={`mb-2 ${
                pathname.startsWith("/bots") && "selected-fill"
              }`}
            />
            <IonLabel color={pathname.startsWith("/bots") ? "secondary" : ""}>
              My Bots
            </IonLabel>
          </IonTabButton>
          <IonTabButton
            tab="lobbies"
            onClick={() => handleTabChange("/lobbies")}
            className="max-w-fit bg-transparent"
          >
            <LobbiesIcon
              className={`mb-2 ${
                pathname.startsWith("/lobbies") && "selected-fill"
              }`}
            />
            <IonLabel
              color={pathname.startsWith("/lobbies") ? "secondary" : ""}
            >
              Lobbies
            </IonLabel>
          </IonTabButton>
          {/* <IonTabButton
            tab="leaderBoard"
            href="/leaderBoard"
            className="max-w-fit bg-transparent"
          >
            <RankIcon
              className={`mb-2 ${
                pathname === "/leaderBoard" && "selected-fill"
              }`}
            />
            <IonLabel>Rank</IonLabel>
          </IonTabButton> */}
          <IonTabButton
            tab="helpCenter"
            onClick={() => handleTabChange("/helpCenter")}
            className="max-w-fit bg-transparent"
          >
            <HelpIcon
              className={`mb-2 ${
                pathname.startsWith("/helpCenter") && "selected-fill"
              }`}
            />
            <IonLabel
              color={pathname.startsWith("/helpCenter") ? "secondary" : ""}
            >
              Help
            </IonLabel>
          </IonTabButton>
        </IonTabBar>
      </IonTabs>
    </>
  );
};

export default RouterContainer;
